import { ElementRef, Injectable } from '@angular/core';
import {
  AutoserviceCategory,
  AutoserviceProductCategory,
} from 'src/app/interfaces/autoservice.interface';
import { AutoserviceCombo } from 'src/app/interfaces/combo.interface';

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  constructor() {}

  public setAppCustomStyleVariables(
    componentStyle: any,
    elementRef: ElementRef
  ): void {
    for (const style in componentStyle) {
      if (typeof componentStyle[style] === 'number') continue;
      if (componentStyle[style as keyof any].includes('/')) {
        elementRef.nativeElement.ownerDocument.documentElement.style.setProperty(
          `--${style}`,
          `url('${componentStyle[style as keyof any]}')`
        );
      } else {
        elementRef.nativeElement.ownerDocument.documentElement.style.setProperty(
          `--${style}`,
          `${componentStyle[style as keyof any]}`
        );
      }
    }
  }

  public convertHexToRGB(hex: string): string {
    if (hex.length === 7) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);

      return `${r}, ${g}, ${b}`;
    } else {
      const r = parseInt(hex.slice(1, 2), 16);
      const g = parseInt(hex.slice(2, 3), 16);
      const b = parseInt(hex.slice(3, 4), 16);

      return `${r}, ${g}, ${b}`;
    }
  }

  public mapProductsToItems(
    autoserviceProductCategories: AutoserviceProductCategory[]
  ): AutoserviceCategory[] {
    return autoserviceProductCategories.map((category) => ({
      categoryId: category.idCategoria,
      categoryImageUrl: category.urlImagen,
      name: category.descripcion,
      items: category.productos.map((product) => ({
        itemId: product.idProducto,
        name: product.nombreProducto,
        description: product.productoDetalle.descripcion,
        price: product.listaPrecios[0].precioProducto,
        type: 'product',
        itemImageUrl: product.productoDetalle.urlImagen,
      })),
    }));
  }

  public mapCombosToItems(combos: AutoserviceCombo[]): AutoserviceCategory {
    return {
      categoryId: 0,
      categoryImageUrl:
        'https://spo-resources-prod.s3.amazonaws.com/productos/1/1/Combos/51/comboPilao.jpg',
      name: 'Combos',
      items: combos.map((combo) => ({
        itemId: combo.idCombo,
        name: combo.nombreCombo,
        description: this.mapComboDescription(combo),
        price: combo.listaPrecios[0].precioProducto,
        type: 'combo',
        itemImageUrl: combo.comboDetalle.urlImagen,
      })),
    };
  }

  public mapComboDescription(combo: AutoserviceCombo) {
    return combo.combosProductos
      .map(
        (comboProduct) =>
          comboProduct.cantidad + ' ' + comboProduct.producto.nombreProducto
      )
      .concat(
        combo.comboOpcionales?.map(
          (optional) => optional.cantidad + ' ' + optional.nombreOpcional
        ) || []
      )
      .join(', ');
  }
}
